//修复低版本浏览器本身的jsapi功能缺失的缺陷
import "./repair"
//核心框架的配置信息
import setting from './setting'
//公共通用的方法
import util from './util'
//http请求库
import http from "./http";
//数组操作
import array from "./array";
//验证通用方法
import validate from "./validate";
//获取路径地址公用方法
import url from "./url";
import './lodash.min';
//框架桥接通用方法
import broadcast from "./broadcast";
//载入组件通用方法
import module from './module';
//表达式执行
import express from './express';
//缓存
import cachePool from './cache';
//应用信息
import app from './app';
//用户信息
import user from './user';
//主题信息
import theme from './theme';
//水印
import watermark from './watermark';
//消息提醒
import message from './message';
//开发工具类
import develop from './develop';
//控制中心（动态属性）
import controlcenter from './controlcenter';
//layer弹窗
import layer from './layer';
//page页面全局功能控制
import page from './page';
//路由管理器
import router from './router';
//css样式工具函数
import style from './transformStyle';
//数据源请求工具
import datasource from './datasource';
//表单通用工具
import form from './form';



let global = window || global;

let IDM = {
    version:setting.version,
    ...util,
    util,
    http,
    array,
    url,
    setting,
    validate,
    broadcast,
    module,
    //标志着是基于核心框架的模式下
    env_dev:true,
    express,
    cachePool,
    app,
    user,
    theme,
    watermark,
    message,
    develop,
    controlcenter,
    layer,
    page,
    router,
    style,
    datasource,
    form
};

//如果window对象存在则表示在客户端运行，否则使用node的global对象作为全局对象
if (global) {
    global.IDM = IDM;
    global._ =_;
}

export default IDM;